import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../utils/api";
import { toast } from "react-toastify";


export const getReceivedOrdersThunk = createAsyncThunk(
    'bom/getReceivedOrdersThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getAllRecievedOrders(data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportRecievedOrderdetailsThunk = createAsyncThunk(
    'bom/exportRecievedOrderdetailsThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getAllRecievedOrders(data);
            
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const getRecievedOrderDetailsThunk = createAsyncThunk(
    'bom/getRecievedOrderDetailsThunk',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getRecievedOrderDetails(data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


const recievedOrderSlice = createSlice({
    name: 'recievedOrders',
    initialState: {
        orders: [],
        orderDetails: {},
        loading: false,
        refresh: false,
       
        page: 1,
        status:''

    },
    reducers: {
        setRecieveOrderPage: (state, action) => {
            state.page = action.payload
        },
        setReceiveOrdersRefresh:(state,action)=>{
            state.refresh = !state.refresh
        },
        setRecievedOrderStatus:(state,action)=>{
            state.status = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getReceivedOrdersThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getReceivedOrdersThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.orders = action.payload
            })
            .addCase(getReceivedOrdersThunk.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(getRecievedOrderDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getRecievedOrderDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.orderDetails = action.payload
            })
            .addCase(getRecievedOrderDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })
    },
})

export const { setRecieveOrderPage,setReceiveOrdersRefresh,setRecievedOrderStatus } = recievedOrderSlice.actions;
export default recievedOrderSlice.reducer
